module.exports = __webpack_public_path__ + "static/media/LeftBu.7471c669.svg";